<!-- 

LISTA DAS FORMAS DE PAGAMENTO CADASTRADAS

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';
import FormaspagamentoForm from './config-formaspagamento-form-loja'

export default {
    props: {
        obj: { type: Object },
    },

    components: {
        FormaspagamentoForm,
    },

    data () {
        return {
            index: null,
            formapagamentoobj: null,
            showForm: false,
            showConfigPayMethods: false
        }
    },

    computed: {

    },

    filters: {

    },

    methods: {
        handleShowConfigPayMethods(){
            this.showConfigPayMethods = !this.showConfigPayMethods
        },
        handleDesativar (formapagamento, idx) {
            this.obj.formaspagamento[idx].excluido = true
            this.$emit('saveconfig')
        },

        handleAtivar (formapagamento, idx) {
            this.obj.formaspagamento[idx].excluido = false
            this.$emit('saveconfig')
        },

        handleNew () {
            this.showConfigPayMethods = true;
            this.index = -1
            this.formapagamentoobj = null
            this.showForm = true
        },

        handleEdit (idx) {
            this.index = idx
            this.formapagamentoobj = {...this.obj.formaspagamento[idx]}
            this.showForm = true
        },

        handleCancel () {
            this.showForm = false
        },

        handleConfirma (formapagamento) {
            this.showForm = false
            if (this.index >= 0)
              this.obj.formaspagamento[this.index] = formapagamento
            else 
              this.obj.formaspagamento.push(formapagamento)
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {

    }

}

</script>

<template>

  <div class="mb-2 container-accordion cursor-pointer " :class="showConfigPayMethods ? 'container-open' : 'container-close'">
    <div class="row mb-2" @click="handleShowConfigPayMethods">
        <div class="col-11">
            <span class="lbl-deal-title mb-3">Outras formas de pagamento</span>
            <br>
            <span>Adicione outras formas de pagamento como "Pagar na retirada", "Combinar com o comprador", "Transferência bancária" ou outra forma que deseja!</span>
        </div>
        <button class="col-auto border-0 bg-transparent" style="outline: none">
            <i :class="'text-secondary fa fa-chevron-' + ( showConfigPayMethods ? 'up' : 'down')"></i>
        </button>
    </div>
    <div class="mb-2">
        <div class="row">
            <div class="col-auto">
                <v-button label="Adicionar" @click="handleNew"></v-button>
            </div>
        </div>
    </div>
    <transaction name="slide">
        <div >
            <div class="border p-3 mb-2 my-4" v-for="(pagamento, index) in obj.formaspagamento" :key="index">
                <div class="row">
                    <div class="col-md-10">
                        <v-label label="Descrição"></v-label>
                        <span class="data-list">{{ pagamento.descricao }}</span>
                    </div>
                    <div class="col-md-2">
                        <v-label label="Desconto"></v-label>
                        <span class="data-list">{{ pagamento.desconto | formatValue(2) }}</span>
                    </div>
                    <div class="col-md-12">
                        <v-label label="Observações"></v-label>
                        <span class="data-list">{{ pagamento.obs }}</span>
                    </div>
                    <div class="col-md-12" v-if="!pagamento.excluido">
                        <v-button label="Desativar" :danger="true" @click="handleDesativar(pagamento, index)"></v-button>
                        <v-button icon="fa-pencil" label="Editar" @click="handleEdit(index)"></v-button>
                    </div>
                    <div class="col-md-12" v-else>
                        <v-button label="Ativar" :success="true" @click="handleAtivar(pagamento, index)"></v-button>
                    </div>
                </div>
            </div>
            <formaspagamento-form v-if="showForm" :obj="formapagamentoobj" @confirma="handleConfirma" @closeform="handleCancel"></formaspagamento-form>
        </div>
    </transaction>
  </div>

</template>

<style scoped>
.container-accordion{
    transition: all .4s;
    overflow-x: hidden;
}
.container-open{
    max-height: 900px;
}

.container-close{
    overflow-y: hidden;
    max-height: 120px;
}
.accordion{
    transition: opacity .4s linear ;
    transition-delay: .0s;
}
.open{
    opacity: 100%;
}
.close{
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/forms-loja/config-formaspagamento-list-loja.vue